import Class from "../../models/Class"
import requestAction, { alertMessage } from "../../utils/requestAction"
import { juxt } from 'ramda'
import { fetchClasses } from "./classList"

export default (aClass: Class, history) =>
  requestAction('CLASS_DELETE')(`classes/${aClass.id}`, 'DELETE', null, juxt([fetchClasses(history.location.search), alertMessage("Clase eliminada")]))